import {ModuleEnum, PermissionOperationEnum} from 'src/api/ProactApiClient';
import {ContentWrapper} from 'src/app/layout/ContentWrapper';
import {ProjectForm} from 'src/app/projects/ProjectForm';
import {routeRegistry} from 'src/pages/RouteRegistry';
import {PathUtility} from 'src/shared/constants/PathBuilder';
import useSetDocumentTitle from 'src/shared/hooks/useSetDocumentTitle';

export const CreateProjectPage = () => {
  useSetDocumentTitle('Create Project');

  return (
    <ContentWrapper>
      <ProjectForm mode="create" />
    </ContentWrapper>
  );
};

routeRegistry.registerPageRoute({
  backNavigation: 'form',
  path: PathUtility.ProjectCreate(),
  element: <CreateProjectPage />,
  module: ModuleEnum.Projects,
  operation: PermissionOperationEnum.Create,
  isPrivate: true,
  allowGlobalAdminBypass: true,
});

export default CreateProjectPage;
